import { getBuyersFilterApi } from "api/common";
import { FC, useRef, useState } from "react";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_TIME_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { Buyer } from "interface/buyer";
import { DateTimePickerComponent } from "ui/Date";
import { PurchaseStatisticFilter } from "api/purchaseStatistic";
import { Vessel } from "interface/vessel";
import { getVesselFilter } from "api/vessel";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: PurchaseStatisticFilter) => void;
	filterOptions: PurchaseStatisticFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const [localFromDate, setLocalFromDate] = useState(filterOptions.fromDate);
	const [localToDate, setLocalToDate] = useState(filterOptions.toDate);
	const pendingFromDate = useRef(filterOptions.fromDate);
	const pendingToDate = useRef(filterOptions.toDate);

	const applyFromDate = () => {
		const newValue = pendingFromDate.current;
		if (newValue === filterOptions.fromDate) return;
		setFilterOptions({
			...filterOptions,
			fromDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyToDate = () => {
		const newValue = pendingToDate.current;
		if (newValue === filterOptions.toDate) return;
		setFilterOptions({
			...filterOptions,
			toDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			vesselLedgerAccountNumber: vessel.res as any,
			take: props.pageSize,
			skip: 0,
		});
	};


	return (
		<div className="filter-container">
			<div className="filter-items purchase-statistic-filter-items">
				<div className="purchase-statistic-filter-field" style={{ width: "200px" }}>
					<div style={{ width: "100%" }}>
						<DateTimePickerComponent
							placeholder=" "
							label={t("FromDate")}
							className="height-inherit"
							format={DATE_TIME_FORMAT}
							value={localFromDate}
							onChange={(e) => {
								pendingFromDate.current = e.target.value;
								setLocalFromDate(e.target.value);
							}}
							onBlur={() => applyFromDate()}
						/>
					</div>
				</div>
				<div className="purchase-statistic-filter-field" style={{ width: "200px" }}>
					<div style={{ width: "100%" }}>
						<DateTimePickerComponent
							placeholder=" "
							label={t("ToDate")}
							className="height-inherit"
							format={DATE_TIME_FORMAT}
							value={localToDate}
							onChange={(e) => {
								pendingToDate.current = e.target.value;
								setLocalToDate(e.target.value);
							}}
							onBlur={() => applyToDate()}
						/>
					</div>
				</div>
				<div className="purchase-statistic-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							nm: filterOptions.vesselName || " ",
						}}
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						itemRender={VesselRenderItem()}
						serverFilterApi={getVesselFilter}
					/>
				</div>

				<div className="purchase-statistic-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer: Buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id as any,
								buyerName: buyer.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							displayName: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="displayName"
						label={t("Buyer")}
						defaultItem={{ id: null, displayName: t("All") }}
						className="height-inherit"
						style={{ width: "100%" }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
			</div>

			<div className="filter-end-btn purchase-statistic-filter-end-btn">
				<CustomButton
					label={"PDF"}
					onClick={() => exportAsPDF()}
					iconName={ICON_NAMES.Download}
				/>
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
